import { lazy, type FC, Suspense } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState.ts';

const EthereumWalletStatus = lazy(
    () => import(/* webpackChunkName: "EthereumWallet" */ './EthereumWalletStatus.tsx')
);

type Props = {
    gaLabel?: string;
    isMobile: boolean;
};

export const EthereumWalletStatusLazy: FC<Props> = props => {
    const isClient = useClientState();
    return isClient ? (
        <Suspense fallback="">
            <EthereumWalletStatus {...props} />
        </Suspense>
    ) : null;
};
